// ----------------------------------------------------------------------
// <copyright file="Izenda.PermissionUserSetup.jsx" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

import React, { Component } from 'react';
import PropTypes from 'prop-types';
import connect from 'share/enhancers/Izenda.Connect';
import GridLayout from 'share/components/controls/Izenda.GridLayout';
import Input from 'share/components/controls/Izenda.Input';
import actions from '../Izenda.PermissionActions';
import { SECTION } from 'logic/data/Izenda.PermissionConstants';
import EventsUtils from 'EventUtils';
import CheckboxAllPermission from './Izenda.CheckboxAllPermission';
import { get, isNil } from 'lodash/fp';

@connect(actions)
export default class PermissionUserSetup extends Component {
  static propTypes = {
    permission: PropTypes.object.isRequired
  };

  componentWillMount() {
    const notifyChange = EventsUtils.notifyChange;
    const { permission } = this.props;
    this.userSetup = this.props.permission.userSetup;

    this.updateTenantAccessParent = notifyChange(
      permission.updateTenantAccessParent.bind(permission, this.userSetup),
      EventsUtils.CHECKBOX
    );
    this.onChangeCreate = notifyChange(
      permission.updateData.bind(permission, this.userSetup.actions, 'create'),
      EventsUtils.CHECKBOX
    );
    this.onChangeEdit = notifyChange(
      permission.updateUserSetupEdit.bind(permission, this.userSetup.actions),
      EventsUtils.CHECKBOX
    );
    this.onChangeDel = notifyChange(
      permission.updateData.bind(permission, this.userSetup.actions, 'del'),
      EventsUtils.CHECKBOX
    );
    this.onChangeConfigureSecurityOptions = notifyChange(
      permission.updateData.bind(permission, this.userSetup.actions, 'configureSecurityOptions'),
      EventsUtils.CHECKBOX
    );
    this.updateTenantAccessUserSetup = notifyChange(
      permission.updateTenantAccess.bind(permission, this.userSetup, this.userSetup.actions),
      EventsUtils.CHECKBOX
    );
    this.onChangeUserRoleAssociation = notifyChange(
      permission.updateData.bind(permission, this.userSetup.userRoleAssociation, 'value'),
      EventsUtils.CHECKBOX
    );
    this.updateTenantAccessUserRoleAssociation = notifyChange(
      permission.updateTenantAccess.bind(permission, this.userSetup, this.userSetup.userRoleAssociation),
      EventsUtils.CHECKBOX
    );
  }

  render() {
    const {
      permissionStore,
      permissionStore: { tenantDetail },
      permission,
      localization,
      isTemplatePermissions,
      readOnly
    } = this.props;
    const userSetup = get('userSetup', tenantDetail);

    return (
      (isNil(tenantDetail) || this.props.checkShowGroupCommon(tenantDetail.userSetup)) && (
        <div className={SECTION.UserSetup}>
          <GridLayout className='izenda-GridLayout-Custom'>
            <GridLayout.Row className='u_textBold u_paddingTop u_paddingBottom izenda-PermissionCategory-Header'>
              <GridLayout.Col cols={2}>
                <a
                  className={this.props.getIconClass('isShowUserSetup')}
                  onClick={this.props.toggle.bind(this, 'isShowUserSetup')}
                />
                {localization.getText('COMMON_LABEL_USER_SETUP')}
              </GridLayout.Col>
              <GridLayout.Col cols={9}>
                <CheckboxAllPermission
                  permission={permission}
                  readOnly={readOnly}
                  disabled={isTemplatePermissions}
                  section={this.userSetup}
                  tenantPermission={userSetup}
                  tenantDetail={tenantDetail}
                />
              </GridLayout.Col>
              {permission.isTenantSetup && (
                <GridLayout.Col cols={1} className='u_textCenter'>
                  <Input
                    type='checkbox'
                    readOnly={readOnly}
                    disabled={isTemplatePermissions}
                    indeterminate={this.props.getIndeterminateCommon(this.userSetup)}
                    checked={this.props.getCheckedCommon(this.userSetup.tenantAccess)}
                    onChange={this.updateTenantAccessParent}
                  />
                </GridLayout.Col>
              )}
            </GridLayout.Row>
          </GridLayout>
          {permissionStore.isShowUserSetup && (
            <GridLayout className='izenda-GridLayout-Custom'>
              {(isNil(tenantDetail) || this.props.checkShowGroupCommon(tenantDetail.userSetup.actions)) && (
                <GridLayout.Row className='u_paddingTop u_paddingBottom'>
                  <GridLayout.Col cols={2} className='izenda-PermissionCategory-SubCategory'>
                    {localization.getText('COMMON_LABEL_ACTIONS')}
                  </GridLayout.Col>
                  <GridLayout.Col cols={9}>
                    {(isNil(tenantDetail) || tenantDetail.userSetup.actions.create) && (
                      <div className='u_inlineBlock izenda-PermissionCategory-group_left'>
                        <label>
                          <Input
                            type='checkbox'
                            readOnly={readOnly}
                            disabled={isTemplatePermissions}
                            checked={this.props.getCheckedCommon(this.userSetup.actions.create)}
                            onChange={this.onChangeCreate}
                          />
                          <span>{localization.getText('COMMON_LABEL_CREATE')}</span>
                        </label>
                      </div>
                    )}
                    {(isNil(tenantDetail) || tenantDetail.userSetup.actions.edit) && (
                      <div className='u_inlineBlock izenda-PermissionCategory-group_left'>
                        <label>
                          <Input
                            type='checkbox'
                            readOnly={readOnly}
                            disabled={isTemplatePermissions}
                            checked={this.props.getCheckedCommon(this.userSetup.actions.edit)}
                            onChange={this.onChangeEdit}
                          />
                          <span>{localization.getText('COMMON_LABEL_EDIT')}</span>
                        </label>
                      </div>
                    )}
                    {(isNil(tenantDetail) || tenantDetail.userSetup.actions.del) && (
                      <div className='u_inlineBlock izenda-PermissionCategory-group_left'>
                        <label>
                          <Input
                            type='checkbox'
                            readOnly={readOnly}
                            disabled={isTemplatePermissions}
                            checked={this.props.getCheckedCommon(this.userSetup.actions.del)}
                            onChange={this.onChangeDel}
                          />
                          <span>{localization.getText('COMMON_LABEL_DELETE')}</span>
                        </label>
                      </div>
                    )}
                    {(isNil(tenantDetail) || tenantDetail.userSetup.actions.configureSecurityOptions) && (
                      <div className='u_inlineBlock izenda-PermissionCategory-group_left'>
                        <label>
                          <Input
                            type='checkbox'
                            checked={this.props.getCheckedCommon(this.userSetup.actions.configureSecurityOptions)}
                            onChange={this.onChangeConfigureSecurityOptions}
                            readOnly={readOnly}
                            disabled={isTemplatePermissions || !this.props.getCheckedCommon(this.userSetup.actions.edit)}
                          />
                          <span>{localization.getText('PERMISSION_LABEL_PASSWORD_OPTIONS')}</span>
                        </label>
                      </div>
                    )}
                  </GridLayout.Col>
                  {permission.isTenantSetup && (
                    <GridLayout.Col cols={1} className='u_textCenter'>
                      <Input
                        type='checkbox'
                        readOnly={readOnly}
                        disabled={isTemplatePermissions}
                        checked={this.props.getCheckedCommon(this.userSetup.actions.tenantAccess)}
                        onChange={this.updateTenantAccessUserSetup}
                      />
                    </GridLayout.Col>
                  )}
                </GridLayout.Row>
              )}
              {(isNil(tenantDetail) || this.props.checkShowGroupCommon(tenantDetail.userSetup.userRoleAssociation)) && (
                <GridLayout.Row className='u_paddingTop u_paddingBottom'>
                  <GridLayout.Col cols={2} className='izenda-PermissionCategory-SubCategory'>
                    {localization.getText('PERMISSION_LABEL_USER_ROLE_ASSOCIATION')}
                  </GridLayout.Col>
                  <GridLayout.Col cols={9}>
                    <div className='u_inlineBlock izenda-PermissionCategory-group_left'>
                      <Input
                        type='checkbox'
                        readOnly={readOnly}
                        disabled={isTemplatePermissions}
                        checked={this.props.getCheckedCommon(this.userSetup.userRoleAssociation.value)}
                        onChange={this.onChangeUserRoleAssociation}
                      />
                    </div>
                  </GridLayout.Col>
                  {permission.isTenantSetup && (
                    <GridLayout.Col cols={1} className='u_textCenter'>
                      <Input
                        type='checkbox'
                        readOnly={readOnly}
                        disabled={isTemplatePermissions}
                        checked={this.props.getCheckedCommon(this.userSetup.userRoleAssociation.tenantAccess)}
                        onChange={this.updateTenantAccessUserRoleAssociation}
                      />
                    </GridLayout.Col>
                  )}
                </GridLayout.Row>
              )}
            </GridLayout>
          )}
        </div>
      )
    );
  }
}



// WEBPACK FOOTER //
// ./ui/modules/Settings/PermissionTab/PermissionBody/Izenda.PermissionUserSetup.jsx